import "core-js/modules/es.array.for-each";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import SearchBox from '../components/searchBox.vue';
import { loading } from '@/decorators';

var HelpCenterPage = function (_super) {
  __extends(HelpCenterPage, _super);

  function HelpCenterPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.mainContent = {};
    _this.isPending = false;
    _this.rfsViewUrl = _this.$config.rfsFileDownloadUrl;
    _this.showCount = 5;
    return _this;
  }

  HelpCenterPage.prototype.created = function () {
    this.queryHtmlResource();
  };

  HelpCenterPage.prototype.handleSearch = function (val) {
    this.$router.push({
      name: 'SearchResult',
      query: {
        keyword: val
      }
    });
  };

  HelpCenterPage.prototype.queryHtmlResource = function () {
    return __awaiter(this, void 0, Promise, function () {
      var resData, content;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.helpCenter.queryHtmlResource({
              key_name: 'help_homepage',
              preview_no: this.$route.query.preview_no || ''
            })];

          case 1:
            resData = _a.sent().data;
            content = resData.content;

            try {
              content = JSON.parse(content);
              console.log(content);
            } catch (e) {}

            this.mainContent = content || {
              main_rule: [],
              guide: [],
              faq: []
            };
            return [2];
        }
      });
    });
  };

  HelpCenterPage.prototype.transforMation = function (childrens, index, moveCount) {
    var _this = this;

    var itemCount = childrens.length / 2;
    var gradientLeftIndex = itemCount;
    var gradientRightIndex = 2 * index - itemCount;
    Object.keys(childrens).forEach(function (key) {
      childrens[key].classList.remove('left');
      childrens[key].classList.remove('right');
      childrens[key].classList.remove('middle');
      childrens[key].classList.remove('left-gradient');
      childrens[key].classList.remove('right-gradient');

      if (Number(key) < index) {
        childrens[key].classList.add('left');
      } else if (Number(key) === index) {
        childrens[key].classList.add('middle');
      } else {
        childrens[key].classList.add('right');
      }

      if (Number(key) === gradientLeftIndex && moveCount !== 0) {
        childrens[key].classList.add('left-gradient');
      }

      if (Number(key) === gradientRightIndex && moveCount !== itemCount - _this.showCount) {
        childrens[key].classList.add('right-gradient');
      }
    });
  };

  HelpCenterPage.prototype.handleJumpLink = function (url) {
    console.log(url);

    if (/^https?:\/\//.test(url)) {
      window.open(url);
    } else {
      this.$router.push({
        path: url
      });
    }
  };

  __decorate([loading('isPending')], HelpCenterPage.prototype, "queryHtmlResource", null);

  HelpCenterPage = __decorate([Component({
    components: {
      SearchBox: SearchBox
    }
  })], HelpCenterPage);
  return HelpCenterPage;
}(Vue);

export default HelpCenterPage;